<nz-skeleton [nzActive]="true" [nzLoading]="isLoaded">
    <nz-layout>
        <div nz-row nzType="flex" nzJustify="center" nzAlign="top">
            <nz-content>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                           <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.chapterCode'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" class="textChar">{{viewModel.content?.chapterCode }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.headingCode'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" class="textChar">{{viewModel.content?.headingCode  }}</div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.SubHeadingCode1'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ viewModel.content?.subHeadingCode1 }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                           <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.SubHeadingCode2'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ viewModel.content?.subHeadingCode2 }}</div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                           <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.tariffCode'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ viewModel.content?.tariffCode }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.hsType'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ viewModel.content?.type }}</div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                           <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.descEnglish'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" class="textChar">{{ viewModel.content?.descriptionInEnglish }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.descOtherLang'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" class="textChar">{{ viewModel.content?.descriptionInSecondLanguage }}</div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.ShortDescEnglish'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" class="textChar">{{ viewModel.content?.shortDescriptionInEnglish?viewModel.content?.shortDescriptionInEnglish:'NA' }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.ShortDescOtherLang'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" class="textChar">{{ viewModel.content?.shortDescriptionInSecondLanguage ?viewModel.content?.shortDescriptionInSecondLanguage :'NA'}}</div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span>Valid From</span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ dateTimeService.getDateFormat(viewModel.content?.validFrom, "YYYY-MM-DD") }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                           <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span>Valid To</span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ dateTimeService.getDateFormat(viewModel.content?.validTo, "YYYY-MM-DD") }}</div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                           <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.UOM'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{viewModel.content?.uom }}</div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.minDuty'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" *ngIf="viewModel.content?.minDuty ===0">NA</div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" *ngIf="viewModel.content?.minDuty !==0"> {{  viewModel.content?.minDuty}} {{ viewModel.content?.currency}} /{{ viewModel.content?.unitName }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.maxDuty'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ viewModel.content?.maxDuty}}% </div>
                        </div>

                    </div>
                </div>
                <div nz-row class="box-color">
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.active'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ viewModel.content?.active  === "Y" ? "Yes" : "No" }}</div>
                        </div>

                    </div>
                    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
                        <div nz-row>
                         <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" class="bold"><span [translate]="'app.label.tariff.dutiable'"></span></div>
                        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24">{{ viewModel.content?.dutiable  === "Y" ? "Yes" : "No" }}</div>
                        </div>

                    </div>
                </div>
                <nz-divider class="mt-sm mb0"></nz-divider>
                <nz-table [nzData]="viewModel.content.tariffRates" [nzPageSize]="10"
                [nzShowPagination]="viewModel.content.tariffRates.length>5?'true':'false'"
                    class="clear-both mt-lg mob-mt-lg" [nzScroll]="{ x: '600px' }">
                    <thead>
                        <tr>
                            <th nzWidth="104px"><span [translate]="'app.label.tariff.tariffCode'"></span></th>
                            <th nzWidth="104px"><span [translate]="'app.label.tariff.validity'"></span></th>
                            <th nzWidth="104px"><span [translate]="'app.label.tariff.rateTypeImp'"></span></th>
                            <th nzWidth="104px"><span [translate]="'app.label.tariff.rateTypeExp'"></span></th>
                            <th nzWidth="104px"><span [translate]="'app.label.tariff.antiDumpingFree'"></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of viewModel.content?.tariffRates; let i = index" [attr.data-index]="i">
                            <td>{{ data?.tariffCode}}</td>
                            <td>{{ dateTimeService.getDateFormat(data?.validFrom, "YYYY-MM-DD") }} - {{ dateTimeService.getDateFormat(data?.validTo, "YYYY-MM-DD") }}</td>
                            <td>{{ data?.rateTypeForImport }}</td>
                            <td>{{ data?.rateTypeForExport?data?.rateTypeForExport:'NA' }}</td>
                            <td>{{ data?.antiDumpingFree ?data?.antiDumpingFree :'NA'}}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </nz-content>
        </div>
    </nz-layout>
</nz-skeleton>
